import { languageActions } from './constants';

export function changeLanguage(language) {
  return {
    type: languageActions.CHANGE_LANGUAGE,
    payload: language,
  };
}
